import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

const SEARCH_CONTAINER_HEIGHRT = 42;

@Component({
  selector: 'app-search-collapse',
  templateUrl: './search-collapse.component.html',
  styleUrls: ['./search-collapse.component.scss']
})
export class SearchCollapseComponent implements OnInit, AfterViewInit  {
  // 是否显示收起展开按钮
  isWrapping: boolean = false;
  collapse: boolean = true;

  // 搜索条件: 有封装了多个搜索条件的组件
  @Input() searchCpn: boolean = false;

  ngAfterViewInit(): void {
    setTimeout(() => this.checkWrap())
  }

  ngOnInit(): void {
    fromEvent(window, 'resize').pipe(debounceTime(400)).subscribe(() => this.checkWrap())
  }

  toggleCollapse() {
    this.collapse = !this.collapse
  }

  checkWrap() {
    const parentElement = document.getElementById('searchContainer');
    const lastChild = parentElement?.lastElementChild;
    let isHidden = false
    let isOverHeight = false

    if (parentElement && lastChild) {
      const parentRect = parentElement.getBoundingClientRect();
      const lastChildRect = lastChild.getBoundingClientRect();
      isHidden = lastChildRect.bottom > parentRect.bottom || lastChildRect.top < parentRect.top;
      isOverHeight = parentRect.height > SEARCH_CONTAINER_HEIGHRT;
    }

    this.isWrapping = isHidden || isOverHeight;
  }
}



